import { Empty, Select, useBreadcrumbRoutes, Wrapper } from '@maxtropy/components';
import styles from './index.module.scss';
import React, { createContext, useEffect, useState } from 'react';
import Forecasting from './components/Forecasting';
import { useRequest } from 'ahooks';
import {
  apiV2MicrogridResolvedGetMicrogridConfigListPost,
  apiV2MicrogridResolvedGetStrategyConfigTimePost,
  apiV2MicrogridResolvedGetStrategySelectListPost,
} from '@maxtropy/intelligent-dispath-apis-v2';
import IncomeAnalysis from './components/IncomeAnalysis';
import BsaElecPrediction from './components/BsaElecPrediction';
import { useLocation } from 'react-router-dom';

const formLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};

export const StrategySimulationContext = createContext<{
  strategyId?: number;
  lastStartTime?: number;
}>({});

const StrategySimulation = () => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const id = urlSearchParams.get('id');
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [microgridId, setMicrogridId] = useState<number>(); // 微电网
  const [strategyId, setStrategyId] = useState<number>(); // 策略

  // 查询微电网
  const { data: microgridsList } = useRequest(() =>
    apiV2MicrogridResolvedGetMicrogridConfigListPost({}).then(res => {
      return res?.list ?? [];
    })
  );

  // 查询策略
  const { data: strategyList } = useRequest(
    () =>
      apiV2MicrogridResolvedGetStrategySelectListPost({ id: microgridId }).then(res => {
        return res.list ?? [];
      }),
    {
      ready: !!microgridId,
      refreshDeps: [microgridId],
    }
  );

  // 获取策略配置的推理开始时间
  const { data: lastStartTime } = useRequest(
    () =>
      apiV2MicrogridResolvedGetStrategyConfigTimePost({ id: strategyId }).then(res => {
        return res.lastTime;
      }),
    {
      ready: !!strategyId,
      refreshDeps: [strategyId],
    }
  );

  // 默认选择第一个微电网的第一个策略
  useEffect(() => {
    if (!microgridsList || microgridsList.length === 0) {
      setMicrogridId(undefined);
    } else if (id) {
      setMicrogridId(Number(id));
    } else {
      setMicrogridId(microgridsList?.[0].configId);
    }
  }, [id, microgridsList]);

  useEffect(() => {
    if (!microgridId || !strategyList || strategyList.length === 0) {
      setStrategyId(undefined);
    } else {
      setStrategyId(strategyList?.[0].strategyId);
    }
  }, [microgridId, strategyList]);

  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? [])]}>
      <div className={styles.contentInner}>
        <div className={styles.filter_wrapper}>
          <div className={styles.select_box}>
            <span className={styles.label}>微电网：</span>
            <Select
              placeholder="请选择"
              style={{ width: 240 }}
              options={(microgridsList ?? []).map(item => ({
                label: item.displayName,
                value: item.configId,
              }))}
              value={microgridId}
              onChange={val => {
                setStrategyId(undefined);
                setMicrogridId(val);
              }}
              showSearch
              optionFilterProp="label"
            />
          </div>

          <div className={styles.select_box}>
            <span className={styles.label}>策略：</span>
            <Select
              placeholder="请选择"
              style={{ width: 240 }}
              options={(strategyList ?? []).map(item => ({
                label: item.strategyName,
                value: item.strategyId,
              }))}
              value={strategyId}
              onChange={val => setStrategyId(val)}
              showSearch
              optionFilterProp="label"
            />
          </div>
        </div>
        {!strategyId ? (
          <Empty />
        ) : (
          <StrategySimulationContext.Provider value={{ strategyId, lastStartTime }}>
            <div className={styles.content_box}>
              <div className={styles.forecasting_box}>
                {/* 预测分析 */}
                <Forecasting />
              </div>
              <div className={styles.income_analy}>
                {/* 收益分析 */}
                <IncomeAnalysis />
              </div>
              <div className={styles.compare_box}>
                {/* 储能站充放电预测 */}
                <BsaElecPrediction />
              </div>
            </div>
          </StrategySimulationContext.Provider>
        )}
      </div>
    </Wrapper>
  );
};

export default StrategySimulation;
